import React, { useState } from "react";
import {
  ActiveCheckbox,
  EditButton,
  DeleteButton,
} from "../../common/TableCols";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Table, Button, Spin, Card, Row, Col } from "antd";
import PropTypes from "prop-types";
import { RecordType } from "../../model/common/RecordType";
import FilterGridDropdown from "../../common/FilterGridDropdown";
import EntryFormFooter from "../../common/EntryFormFooter";
import { useTranslation } from "react-i18next";

export const ClinicsForm = ({
  isLoading,
  clinics,
  onAdd,
  onEdit,
  onDelete,
  onRowSelected,
  rowSelected,
  setCurrentPage,
  currentPage,
}) => {
  const { t } = useTranslation();
  const ClinicActiveCheckbox = (value) => <ActiveCheckbox isChecked={value} />;

  const [searchText, setSearchText] = useState("");

  const ClinicActionButtons = (value, record) => (
    <Row>
      <Col span={12}>
        <EditButton fncEdit={() => onEdit(value)} />
      </Col>
      <Col
        span={12}
        style={{
          display: record.RcdType === RecordType.USER ? "" : "none",
        }}
      >
        <DeleteButton fncDelete={() => onDelete(value)} />
      </Col>
    </Row>
  );

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: t("clinicsForm.clinic_code"),
      dataIndex: "ClinicCode",
      key: "ClinicCode",
      width: 200,
      sorter: (a, b) => a.ClinicCode.localeCompare(b.ClinicCode),
      sortDirections: ["ascend", "descend"],
      ...FilterGridDropdown(
        "ClinicCode",
        searchText,
        handleSearch,
        handleReset,
        "Clinic Code",
        t
      ),
    },
    {
      title: t("clinicsForm.clinic_name"),
      dataIndex: "ClinicName",
      key: "ClinicName",
      width: 200,
      sorter: (a, b) => a.ClinicName.localeCompare(b.ClinicName),
      sortDirections: ["ascend", "descend"],
      ...FilterGridDropdown(
        "ClinicName",
        searchText,
        handleSearch,
        handleReset,
        "Clinic Name",
        t
      ),
    },
    {
      title: t("general.description"),
      dataIndex: "ClinicDesc",
      key: "ClinicDesc",
      sorter: (a, b) => a.ClinicDesc.localeCompare(b.ClinicDesc),
      sortDirections: ["ascend", "descend"],
      ...FilterGridDropdown(
        "ClinicDesc",
        searchText,
        handleSearch,
        handleReset,
        "Description",
        t
      ),
    },
    {
      title: t("general.active"),
      dataIndex: "Active",
      key: "Active",
      align: "center",
      width: 100,
      render: ClinicActiveCheckbox,
    },
    {
      title: t("general.action"),
      dataIndex: "ClinicKey",
      key: "ClinicActions",
      align: "center",
      width: 100,
      render: ClinicActionButtons,
    },
  ];

  const tablePaginationChanged = (page) => {
    setCurrentPage(page);
  };

  return (
    <Card
      title={
        <span className="form-title">{t("clinicsForm.clinic_setup")}</span>
      }
      extra={
        <Button
          icon={<PlusCircleOutlined />}
          size="large"
          type="primary"
          style={{ border: "1px solid #fff" }}
          onClick={() => onAdd()}
        >
          {t("general.new")}
        </Button>
      }
    >
      <Spin spinning={isLoading}>
        <Table
          dataSource={clinics}
          columns={columns}
          size="middle"
          pagination={{
            defaultCurrent: currentPage,
            onChange: tablePaginationChanged,
          }}
          rowKey={(record) => record.ClinicKey}
          scroll={{ y: "calc(100vh - 270px)" }}
          onRow={(r) => ({ onClick: () => onRowSelected(r) })}
        />
      </Spin>
      <EntryFormFooter
        footerData={rowSelected}
        showFooter={rowSelected.UpdatedBy ? true : false}
        isApproved={false}
        isVoid={false}
        isPending={false}
        t={t}
      ></EntryFormFooter>
    </Card>
  );
};

ClinicsForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  clinics: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRowSelected: PropTypes.func.isRequired,
  rowSelected: PropTypes.object.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
};

export default ClinicsForm;
